// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2Dte3","topBottomGutter":"Layout_topBottomGutter__1QOsC"};